import { FormsRegisterStaticField } from './forms-register-static-field';
import { StaticFieldIds } from './static-field-ids.enum';

export class FormsRegisterProjectField extends FormsRegisterStaticField {
  public readonly id = StaticFieldIds.Project;
  public content: string;
  public selectedItems: Array<any>;

  constructor({ form, template }: any) {
    super({ form, template });
    this.content = form.template.project._id;
    this.selectedItems = [
      {
        value: form.template.project.name,
        style: 'clean',
      },
    ];
  }
}
